import React from 'react'
import clp from '../images/our_services/CLP.jpg';
import clp2x from '../images/our_services/CLP2x.jpg';
import Image from 'next/image';
const  CLPInstall =()=> {
  return (
    <div>
      <Image  src={clp} alt="Building installation of Ashlok Safe Earthing Electrode with Lightning Protection system and Earthing solution"
                        srcSet={`${clp} 1x, ${clp2x}2x`}/>
    </div>
  )
}
export default  CLPInstall;
